export default function MainHeader() {
    return (
      <div className="relative flex w-full flex-wrap items-center justify-between bg-zinc-50 shadow-dark-mild">
        <div className="flex w-full flex-wrap items-center justify-between px-3">
          <div>
            <a className="mx-2 flex items-center lg:mb-0 lg:mt-0" href="https://www.kenyans.co.ke/">
              <img
                className="md:w-40"
                width={100}
                height={200}
                src="/images/Kenyans Logo Full Color-2.svg"
                alt="Kenyans logo"
              />
            </a>
          </div>
          <div>
            <div  className="bg-red-600 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
              <a className="text-white p-4" href="https://www.kenyans.co.ke/">Visit Site</a>
            </div>
          </div>
        </div>
      </div>
    );
  }